import {
  getAllDefaultValuesFromMetadata,
  getArgumentNamesFromMetadata,
  getDefaultValueFromMetadata,
  makeArgumentsPrivate,
  pickArgs,
  setupDocumentationData,
  sortMetadata,
} from './metadata/helpers';

import {
  ACCESSIBILITY_ARGS,
  ACTION_ARGS,
  ALL_LAYOUT_ARGS,
  COMPONENT_STATE_ARGS,
  CONTAINER_ARGS,
  FLEX_ARGS,
  GRID_ARGS,
  POSITIONING_ARGS,
} from './metadata/shared-arguments';

// Re-export all helpers
export {
  getAllDefaultValuesFromMetadata,
  getArgumentNamesFromMetadata,
  getDefaultValueFromMetadata,
  makeArgumentsPrivate,
  pickArgs,
  setupDocumentationData,
  sortMetadata,
};

// Re-export all shared arguments
export {
  ACCESSIBILITY_ARGS,
  ACTION_ARGS,
  ALL_LAYOUT_ARGS,
  COMPONENT_STATE_ARGS,
  CONTAINER_ARGS,
  FLEX_ARGS,
  GRID_ARGS,
  POSITIONING_ARGS,
};

export default {
  getAllDefaultValuesFromMetadata,
  getArgumentNamesFromMetadata,
  getDefaultValueFromMetadata,
  makeArgumentsPrivate,
  pickArgs,
  setupDocumentationData,
  sortMetadata,
  ACCESSIBILITY_ARGS,
  ACTION_ARGS,
  ALL_LAYOUT_ARGS,
  COMPONENT_STATE_ARGS,
  CONTAINER_ARGS,
  FLEX_ARGS,
  GRID_ARGS,
  POSITIONING_ARGS,
};
